<main class="h-screen flex flex-col overflow-x-hidden pt-5 pb-3.5">
  <app-header></app-header>

  <div class="mt-auto">
    <router-outlet></router-outlet>
  </div>
</main>
